<div
  class="flex flex-col p-6 space-y-2 rounded-lg border border-border h-full"
  [ngClass]="{
    'border-green bg-green/15': solution().isGreener,
    'border-border bg-white': !solution().isGreener,
  }">
  <div class="flex flex-row items-center gap-2">
    <h2
      class="text-xl font-semibold"
      [ngClass]="{
        'text-green': solution().isGreener,
        'text-text-primary': !solution().isGreener,
      }">
      {{ solution().name }}
    </h2>
    @if (solution().isGreener) {
      <lucide-icon class="w-4 h-4 text-green" [name]="badge" />
    }
  </div>

  <div class="flex flex-col gap-2">
    @for (product of products(); track product.id) {
      <div>
        <button
          class="w-full flex items-center justify-start gap-2 hover:text-text-primary/80 cursor-pointer"
          type="button"
          [attr.aria-controls]="'prod-' + product.id"
          [attr.aria-expanded]="isOpen(product.id)"
          (click)="toggle(product.id)">
          <span class="transition-transform duration-200" [class.rotate-90]="isOpen(product.id)">
            <lucide-icon class="w-4 h-4" [name]="chevronRight" />
          </span>

          <div class="flex flex-row items-center gap-2">
            <span class="font-semibold">{{ product.quantity }}x</span>
            <span class="text-left">{{ product.name }}</span>
          </div>
        </button>

        @if (isOpen(product.id)) {
          <div animate.enter="accordion-enter" animate.leave="accordion-leave" [id]="'prod-' + product.id">
            <div class="accordion-inner">
              @for (property of product.properties; track property.label) {
                <div class="pl-6 mt-2 flex flex-row items-center justify-between text-text-secondary">
                  <div class="flex flex-row items-center space-x-2">
                    @if (property.icon) {
                      <lucide-icon class="w-4 h-4" [name]="property.icon" />
                    }
                    <span>{{ property.label }}</span>
                  </div>
                  <div class="flex flex-row items-center space-x-1 text-text-primary">
                    <span>{{ property.value }}</span>
                    @if (property.unit) {
                      <span>{{ property.unit }}</span>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>

  <div class="flex flex-row items-center justify-between text-text-secondary">
    <span>Rental fee</span>
    <div class="flex flex-row items-center space-x-1 text-text-primary">
      <span>{{ solution().kpis.rentalFeeTotal }}</span>
      @if (solution().kpis.currencyUnit) {
        <span>{{ solution().kpis.currencyUnit }}</span>
      }
    </div>
  </div>

  @if (solution().description) {
    <div>
      <p class="text-text-secondary">Description</p>
      <p>{{ solution().description }}</p>
    </div>
  }
</div>
